<h3 mat-dialog-title>{{ 'map.tools.sentryScheduleDialog.title' | t }}</h3>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ 'common.timezone' | t }}</mat-label>
    <mat-select
      [(ngModel)]="timezone"
      name="timezone"
      [placeholder]="'map.tools.sentryScheduleDialog.timezonePlaceholder' | t"
      ngDefaultControl
    >
      <mat-option *ngFor="let tz of timezoneOptions" [value]="tz">{{ tz }}</mat-option>
    </mat-select>
  </mat-form-field>
  <sn-weekly-scheduler
    [schedules]="data.schedules"
    (saveClick)="setSchedules($event)"
  ></sn-weekly-scheduler>
  <button mat-button color="danger" class="cancelButton" (click)="cancel()">
    {{ 'common.cancel' | t }}
  </button>
</mat-dialog-content>
